import store from '@/plugins/store'

const Error = function (to, from, next) {
  store.dispatch('auth/check')
    .finally(() => {
      if (!(store.getters['auth/isLogged'] && store.getters['auth/hasRole'](to.meta.role))) {
        next('/error')
      }

      if (!store.getters['auth/isUnLogged']) {
        next('/error')
      }
    })
}

export default Error
